module.exports = __webpack_public_path__ + "img/accessory_shirt_02.9c3a6849.svg";